import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import styles from './learn-teach-search.module.css';
import NavHeader from '../shared/Nav-Header';
import defaultProfile from '../images/default-profile1.jpg';
import Notification from '../shared/Notification';

const LearnTeachSearch = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const toLearn = queryParams.get('toLearn') || '';
    const toTeach = queryParams.get('toTeach') || '';
    const language = queryParams.get('language') || '';
    const [results, setResults] = useState([]);
    const navigate = useNavigate();
    const [showLearnTeachHistory, setShowLearnTeachHistory] = useState(false);
    const [showSocialView, setShowSocialView] = useState(false);
    const [profileSelected, setProfileSelected] = useState([]);
    const [notification, setNotification] = useState('');
    const [offersSent, setOffersSent] = useState([]);
    const offered = (resultId) => offersSent.includes(resultId);
    const token = useMemo(() => localStorage.getItem('token'), []);


    useEffect(() => {
        const fetchSearchResults = async () => {
            try {
                const response = await axios.get('/api/learn-teach/search', {
                    params: { toLearn, toTeach, language },
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                // console.log('Search results fetched:', response.data);
                setResults(response.data);
            }
            catch (error) {
                // console.error('Error fetching search results:', error);
            }
        };

        fetchSearchResults();
    }
    , [toLearn, toTeach, language]);

    const handleOffer = async (e, profileId) => {
        e.preventDefault();
        try{
            const response = await axios.post(`/api/learn-teach/offer-send/${profileId}`, {toLearn, toTeach, language}, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            console.log('Offer response:', response.data);
            if(response.data.success){
                setNotification('Offer sent');
                setOffersSent(prevOffersSent => [...prevOffersSent, profileId]); // Update applied jobs
            }
        } catch (error) {
            // console.error('Error creating offer:', error);
            if(error.response?.status === 409){
                setNotification(error.response.data.message ||'Offer already sent to this profile');
                // console.log(error.response.data.message || 'Offer already sent to this profile');
            }
        }
    }

    const handleLearnTeachHistoryView = ( dateJoined, learningTeachingCompleted) => {
       let status;
    
        if (!dateJoined) {
            status = { color: 'purple', text: 'Date Joined not available' };
        } else {
            const now = new Date();
            const joinedDate = new Date(dateJoined);
            const diffInMs = now - joinedDate;
            const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
            status = { color: 'blue', text: `Joined ${diffInDays} days ago` };
        }
        setProfileSelected({ status, learningTeachingCompleted});
        setShowLearnTeachHistory(true);
    }
    const handleSocialButtonClick = (about, lastSeen) => {
       let status;
    
        if (!lastSeen) {
            status = { color: 'purple', text: 'Never seen' };
        } else {
            const now = new Date();
            const lastSeenDate = new Date(lastSeen);
            const diffInMs = now - lastSeenDate;
            const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
            
            if (diffInDays <= 1) {
                status = { color: 'green', text: 'Active within last 24hrs.' };
            } else if (diffInDays <= 21) { // 3 weeks = 21 days
                status = { color: 'yellow', text: `Active within 3 weeks ` };
            } else {
                status = { color: '#aa3ce6ff', text: `Inactive for over 3 weeks `};
            }
        }
        setProfileSelected({about, status, lastSeen});
        setShowSocialView(true);
    }
    const handleProfileClick = (profileId) => () => {
        navigate(`/profile/${profileId}`);
    }
    const handleGoBackAndSetEditTrue = () => () => {
        navigate('/learn-teach?edit=true');
    }
    const handleCloseNotification = () => {
        setNotification('');
    };

    return (
        <div className={styles.LearnTeachSearchContainer}>
            <NavHeader/>
            {notification && (
                <Notification message={notification} onClose={handleCloseNotification} />
            )}
            <h2>Learn/Teach Search Results</h2>
            {results.length === 0 ? (
                <>
                <p>No results found.</p>
                <button className={styles.changeFiltersButton} onClick={handleGoBackAndSetEditTrue()} >Change Filters</button>
                </>
            ) : (
                <ul>
                    {results.map((profile) => (
                        <li key={profile._id} className={styles.profileItem}>
                            <div  onClick={handleProfileClick(profile._id)}>
                                <img title={profile.name} src={profile?.profilePicture ? profile?.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile} alt={`${profile.name}'s profile`} className={styles.profilePicture} />
                            <h3>{profile.name}</h3>
                            <p>To Learn: {profile.toLearn}</p>
                            <p>To Teach: {profile.toTeach}</p>
                            <p>Language: {profile.language}</p>
                        </div>
                        <div className={styles.buttonContainer}>
                            <button
                                className={`${styles.offerButton} ${offered(profile._id) ? styles.offered : ''}`}
                                onClick={(e) => handleOffer(e, profile._id,)}
                                disabled={offered(profile._id)}
                            >
                                {offered(profile._id) ? (
                                    'Offered'
                                ) : (
                                    'Offer'
                                )}
                            </button>
                            <button className={styles.leearnTeachHistoryButton} onClick={()=>handleLearnTeachHistoryView(profile?.dateJoined, profile?.learningTeachingCompleted)}
                            >LearnTeach History</button>
                            <button className={styles.socialButton} onClick={()=>handleSocialButtonClick(profile?.about, profile?.lastSeen)}>Social</button>
                        </div>
                    </li>
                    ))}
                </ul>
            )}
            {showLearnTeachHistory && (
                <div className={styles.learnTeachHistoryModal}>
                    <div className={styles.learnTeachHistoryContent}>
                        <h2>Learn/Teach History</h2>
                        <p>Date Joined: {profileSelected?.status.text} <span 
                            className={styles.statusIndicator} 
                            style={{ backgroundColor: profileSelected.status.color }}
                            title={profileSelected.status.text}
                        /></p>
                        <p> </p>
                        <p> Learning-Teaching Completed: {profileSelected?.learningTeachingCompleted}</p>
                        <button onClick={() => setShowLearnTeachHistory(false)}>Close</button>
                    </div>
                </div>
            )}
            {showSocialView && (
                <div className={styles.socialModal}>
                    <div className={styles.socialContent}>
                        <h2>Social View</h2>
                        <p>Last Active:  {profileSelected?.lastSeen ? profileSelected.status.text : 'N/A'} 
                         <span 
                            className={styles.statusIndicator} 
                            style={{ backgroundColor: profileSelected.status.color }}
                            title={profileSelected.status.text}
                        /></p>
                        <p>About Them: {profileSelected?.about || 'N/A'}</p>
                        <button onClick={() => setShowSocialView(false)}>Close</button>
                    </div>
                </div>
            )}
        </div>
    );
}
export default LearnTeachSearch;

